export const COMPANY_NAME = "KYRIE PETRAKIS"
export const LOGO1 = require('../assets/logo-1.png');
export const LOGO2 = require('../assets/logo-2.png');
export const HERO_BG_IMG = require('../assets/s2.webp');
export const HERO_BG_IMG1 = require('../assets/photo-1505664063603-28e48ca204eb.avif');
export const HERO_BG_IMG2 = require('../assets/photo-1505664194779-8beaceb93744.avif');
export const HERO_BG_IMG3 = require('../assets/photo-1589994965851-a8f479c573a9.avif');
export const HERO_BG_IMG4 = require('../assets/premium_photo-1661497281000-b5ecb39a2114.avif');
export const ABOUT_BG = require('../assets/pexels-sora-shimazaki-5668473.jpg');
export const TESTIMONIALS_BG_IMG = require('../assets/design-img.png');
export const INCOME_TAX_ICO = require('../assets/taxes_4749988.png');
export const GST_ICO = require('../assets/tax_9323080.png');
export const CRIMINAL_ICO = require('../assets/man_4406773.png');
export const CIVIL_ICO = require('../assets/auction_783196.png');
export const OTHHERS_ICO = require('../assets/justice-scale_12088194.png');
export const WHYUS_BG = require('../assets/photo-1417733403748-83bbc7c05140.avif');
export const INCOME_TAX = require('../assets/premium_photo-1678567671319-cd5273f97b1d.avif');
export const OTHERS = require('../assets/photo-1565598469107-2bd14ae7e7e4.avif');
export const CIVIL = require('../assets/photo-1589829545856-d10d557cf95f.avif');
export const GST = require('../assets/premium_photo-1661373704604-7c4d230c8928.avif');
export const CRIMINAL = require('../assets/premium_photo-1683121172414-235bd5997eed.avif');